import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/谱尼";
import { Soulmark } from "../../core/soulmark";
import { Skin } from "../../core/skin";

export class 谱尼 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(300, "谱尼", type.圣灵, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "虚无：自身受到攻击伤害后，免疫下1次受到的攻击伤害",
            "元素：登场时消除对手的回合类效果，消除成功则使对手下1次释放的技能无效",
            "能量：回合结束时，附加自身已损失体力值的1/2的固定伤害给对手",
            "生命：回合结束时，恢复自身最大体力的1/4和随机2个pp值不为满的技能各1点pp值",
            "轮回：自身首次被击败后重生一次，重生后恢复自身最大体力的1/1和所有技能pp值",
            "永恒：回合开始时，若自身体力高于对手则当回合所有技能必定先出手",
            "圣洁：免疫所有异常状态，且不受能力下降效果影响",
        ]);
        this.技能组 = [
            skill.圣堂之门,
            skill.璨灵圣光,
            skill.千烈虚光闪,
            skill.旋灭裂空阵,
            skill.圣灵魔闪光,
        ];
        this.皮肤组.push(new Skin(5000, "圣灵·谱尼"));
        this.皮肤组.push(new Skin(1400714, "至高真神·谱尼"));
        this.皮肤组.push(new Skin(1400774, "世界之脉·谱尼"));
    }
}
